import { IconCalendarOutline } from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { TDocRequirementReview } from 'components/Documents/DocumentGroup/DocumentGroup';
import { useLocale } from 'hooks/useLocale';
import styles from './MissingCoverages.module.css';

type TProps = {
  coverages: TDocRequirementReview['bank_account_coverages'];
  statusGroup: string;
};

export const MissingCoverages = ({ coverages, statusGroup }: TProps) => {
  const { i18n } = useLocale();

  const renderFormattedDate = (date: string) =>
    i18n.date(date, {
      day: '2-digit',
      month: '2-digit',
      year: '2-digit',
    });

  return (
    <div
      className={clsx(styles.container, {
        [styles.overridden]: statusGroup === 'overridden',
      })}
    >
      {coverages.map((coverage, index) => {
        if (coverage.missing_coverages.length === 0) return null;

        const accountNumber = coverage.bank_transactions_account_number;
        const last4 =
          accountNumber !== undefined ? String(accountNumber).slice(-4) : '';

        const firstRange = coverage.missing_coverages[0];
        const key =
          accountNumber ??
          `${firstRange.start_date}-${firstRange.end_date}-${index}`;

        return (
          <div key={key} className={styles.coverageContainer}>
            <div className={styles.headerContainer}>
              <div className={styles.iconContainer}>
                <IconCalendarOutline
                  width={20}
                  height={20}
                  className={
                    statusGroup === 'overridden'
                      ? styles.overriddenIcon
                      : styles.rejectedIcon
                  }
                />
              </div>
              <p className={styles.title}>
                {accountNumber !== undefined ? (
                  <Trans>
                    Missing statements for account ***{last4} for the period:
                  </Trans>
                ) : (
                  <Trans>Missing statements for the period:</Trans>
                )}
              </p>
            </div>
            <div className={styles.feedbackContainer}>
              <ul className={styles.list}>
                {coverage.missing_coverages.map((range) => (
                  <li key={`${range.start_date}-${range.end_date}`}>
                    {renderFormattedDate(range.start_date)} -{' '}
                    {renderFormattedDate(range.end_date)}
                  </li>
                ))}
              </ul>
              <p className={styles.footer}>
                <Trans>
                  Please upload a statement for this period and ensure it
                  contains the balances and all transactions.
                </Trans>
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
